<template>
    <div class="sys-log-container">
        <!-- 搜索筛选卡片 -->
        <div class="search-card">
            <div class="card">
                <div class="card-header">
                    <span>筛选条件</span>
                </div>
                <div class="card-body">
                    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="80px">
                        <el-form-item label="模块" prop="module">
                            <el-select v-model="queryParams.module" placeholder="请选择模块" clearable style="width: 160px">
                                <el-option label="教务管理" value="教务管理"/>
                                <el-option label="系统管理" value="系统管理"/>
                                <el-option label="手机端" value="手机端"/>
                                <el-option label="微信" value="微信"/>
                                <el-option label="其他模块" value="其他模块"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="操作描述" prop="operateDesc">
                            <el-input v-model="queryParams.operateDesc" placeholder="请输入操作描述" clearable style="width: 180px"/>
                        </el-form-item>
                        <el-form-item label="用户名" prop="userName">
                            <el-input v-model="queryParams.userName" placeholder="请输入用户名" clearable style="width: 160px"/>
                        </el-form-item>
                        <el-form-item label="来源" prop="source">
                            <el-select v-model="queryParams.source" placeholder="请选择来源" clearable style="width: 140px">
                                <el-option label="PC端" value="PC端"/>
                                <el-option label="手机H5" value="手机H5"/>
                                <el-option label="微信小程序" value="微信小程序"/>
                                <el-option label="App端" value="App端"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态" prop="status">
                            <el-select v-model="queryParams.status" placeholder="请选择状态" clearable style="width: 120px">
                                <el-option label="成功" :value="0"/>
                                <el-option label="异常" :value="1"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <!-- 数据表格卡片 -->
        <div class="table-card">
            <div class="card">
                <div class="card-header">
                    <span>系统操作日志</span>
                </div>
                <div class="card-body">
                    <el-table
                        :data="tableData"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%"
                        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                    >
                        <el-table-column type="index" label="序号" width="60" align="center"/>
                        <el-table-column prop="module" label="模块" width="100" align="center"/>
                        <el-table-column prop="userName" label="操作人" width="120" align="center"/>
                        <el-table-column prop="operateDesc" label="操作描述" min-width="160" show-overflow-tooltip/>
                        <el-table-column prop="source" label="来源" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.source === 'PC端'" type="success" size="small">{{ scope.row.source }}</el-tag>
                                <el-tag v-else-if="scope.row.source === '手机H5'" type="primary" size="small">{{ scope.row.source }}</el-tag>
                                <el-tag v-else-if="scope.row.source === '微信小程序'" size="small">{{ scope.row.source }}</el-tag>
                                <el-tag v-else-if="scope.row.source === 'App端'" type="warning" size="small">{{ scope.row.source }}</el-tag>
                                <el-tag v-else type="info" size="small">{{ scope.row.source }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="requestMethod" label="请求方式" width="90" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.requestMethod === 'GET'" type="success" size="small">GET</el-tag>
                                <el-tag v-else-if="scope.row.requestMethod === 'POST'" type="primary" size="small">POST</el-tag>
                                <el-tag v-else-if="scope.row.requestMethod === 'PUT'" type="warning" size="small">PUT</el-tag>
                                <el-tag v-else-if="scope.row.requestMethod === 'DELETE'" type="danger" size="small">DELETE</el-tag>
                                <el-tag v-else type="info" size="small">{{ scope.row.requestMethod }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="requestUri" label="请求地址" min-width="200" show-overflow-tooltip/>
                        <el-table-column prop="elapsedTime" label="耗时(ms)" width="90" align="center" sortable/>
                        <el-table-column prop="ipAddress" label="IP地址" width="140" align="center"/>
                        <el-table-column prop="status" label="状态" width="80" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.status === 0" type="success" size="small">成功</el-tag>
                                <el-tag v-else type="danger" size="small">异常</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="操作时间" width="170" align="center"/>
                        <el-table-column label="操作" width="100" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <div class="pagination-container">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryParams.pageNum"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="queryParams.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- 查看详情对话框 -->
        <el-dialog
            title="操作日志详情"
            :visible.sync="dialogVisible"
            width="800px"
            :close-on-click-modal="false"
        >
            <el-descriptions :column="2" border size="medium" v-if="currentRow">
                <el-descriptions-item label="模块">{{ currentRow.module }}</el-descriptions-item>
                <el-descriptions-item label="操作描述">{{ currentRow.operateDesc || '-' }}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{ currentRow.userName }}（ID: {{ currentRow.userId }}）</el-descriptions-item>
                <el-descriptions-item label="来源">{{ currentRow.source }}</el-descriptions-item>
                <el-descriptions-item label="请求方式">
                    <el-tag v-if="currentRow.requestMethod === 'GET'" type="success" size="small">GET</el-tag>
                    <el-tag v-else-if="currentRow.requestMethod === 'POST'" type="primary" size="small">POST</el-tag>
                    <el-tag v-else-if="currentRow.requestMethod === 'PUT'" type="warning" size="small">PUT</el-tag>
                    <el-tag v-else-if="currentRow.requestMethod === 'DELETE'" type="danger" size="small">DELETE</el-tag>
                    <el-tag v-else type="info" size="small">{{ currentRow.requestMethod }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="请求地址" :span="2">{{ currentRow.requestUri }}</el-descriptions-item>
                <el-descriptions-item label="IP地址">{{ currentRow.ipAddress }}</el-descriptions-item>
                <el-descriptions-item label="耗时">{{ currentRow.elapsedTime }}ms</el-descriptions-item>
                <el-descriptions-item label="状态">
                    <el-tag v-if="currentRow.status === 0" type="success" size="small">成功</el-tag>
                    <el-tag v-else type="danger" size="small">异常</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="操作时间">{{ currentRow.createTime }}</el-descriptions-item>
                <el-descriptions-item label="请求参数" :span="2">
                    <div class="detail-text">{{ currentRow.requestParams || '无参数' }}</div>
                </el-descriptions-item>
                <el-descriptions-item v-if="currentRow.responseResult" label="响应结果" :span="2">
                    <div class="detail-text">{{ currentRow.responseResult }}</div>
                </el-descriptions-item>
                <el-descriptions-item v-if="currentRow.errorMsg" label="异常信息" :span="2">
                    <div class="detail-text error-text">{{ currentRow.errorMsg }}</div>
                </el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
import {reqSysOperationLogPage} from '@/api/monitor/sysOperationLog'

export default {
    name: 'SysOperationLog',
    data() {
        return {
            loading: false,
            tableData: [],
            total: 0,
            queryParams: {
                pageNum: 1,
                pageSize: 20,
                module: undefined,
                operateDesc: undefined,
                userName: undefined,
                source: undefined,
                status: undefined
            },
            dialogVisible: false,
            currentRow: null
        }
    },
    created() {
        this.load()
    },
    methods: {
        /** 加载数据 */
        async load() {
            this.loading = true
            const params = {}
            for (const key in this.queryParams) {
                if (this.queryParams[key] !== undefined && this.queryParams[key] !== '') {
                    params[key] = this.queryParams[key]
                }
            }
            let data=await reqSysOperationLogPage(params);
            this.tableData = data.records || []
            this.total = data.total || 0
            this.loading = false
        },

        /** 查询 */
        handleSearch() {
            this.queryParams.pageNum = 1
            this.load()
        },

        /** 重置 */
        handleReset() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 20,
                module: undefined,
                operateDesc: undefined,
                userName: undefined,
                source: undefined,
                status: undefined
            }
            this.load()
        },

        /** 分页大小变化 */
        handleSizeChange(val) {
            this.queryParams.pageSize = val
            this.queryParams.pageNum = 1
            this.load()
        },

        /** 当前页变化 */
        handleCurrentChange(val) {
            this.queryParams.pageNum = val
            this.load()
        },

        /** 查看详情 */
        handleView(row) {
            this.currentRow = row
            this.dialogVisible = true
        }
    }
}
</script>

<style scoped lang="scss">
.sys-log-container {
    padding: 20px;

    .card {
        background: #fff;
        border-radius: 4px;
        margin-bottom: 20px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

        .card-header {
            padding: 15px 20px;
            border-bottom: 1px solid #ebeef5;
            font-size: 16px;
            font-weight: 600;
            color: #303133;
            display: flex;
            align-items: center;

            &::before {
                content: '';
                display: inline-block;
                width: 4px;
                height: 16px;
                background: #409eff;
                margin-right: 10px;
                border-radius: 2px;
            }
        }

        .card-body {
            padding: 20px;
        }
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .detail-text {
        max-height: 300px;
        overflow-y: auto;
        white-space: pre-wrap;
        word-break: break-all;
        font-family: 'Courier New', Courier, monospace;
        font-size: 13px;
        color: #606266;
        background: #f5f7fa;
        padding: 10px;
        border-radius: 4px;
        line-height: 1.6;
    }

    .error-text {
        color: #f56c6c;
        background: #fef0f0;
    }
}

@media screen and (max-width: 768px) {
    .sys-log-container {
        padding: 10px;
    }
}
</style>
